<template>
    <div class="loader-container">
        <SyncLoader :color="color" :size="size"></SyncLoader>
    </div>
</template>

<script lang="ts">
import SyncLoader from "vue-spinner/src/SyncLoader.vue";

export default {
    name: "Loader",
    components: {
        SyncLoader
    },
    props: {
        size: {
            type: String,
            default: "15px"
        }
    },
    data() {
        return {
            color: "var(--primary)"
        };
    }
};
</script>
<style scoped>
.loader-container {
    filter: saturate(1000%);
}
</style>
